import type { FlavorConfig } from '@/types/flavor';

/**
 * Sideconvo LOCAL Environment Configuration
 */
const config: FlavorConfig = {
  name: 'sideconvo',
  environment: 'local',
  appTitle: 'Lead Management | Sideconvo.ai',
  firestoreDB: 'lead-management-dev',
  demoSiteBaseUrl: 'https://dev.client.sideconvo.ai',
  snapshotBucket: 'snapshot-sideconvo-dev',
};

export default config;
